import React from 'react';

function GlobalStatsCard({ icon: Icon, title, value, subtitle, color, trend }) {
  return (
    <div style={{ ...styles.card, borderLeft: `4px solid ${color}` }}>
      <div style={styles.iconContainer}>
        <Icon size={32} color={color} />
      </div>

      <div style={styles.content}>
        <p style={styles.title}>{title}</p>
        <h2 style={styles.value}>{value}</h2>
        <div style={styles.footer}>
          <span style={styles.subtitle}>{subtitle}</span>
          {trend && (
            <span style={{ ...styles.trend, color: trend > 0 ? '#06D6A0' : '#EF476F' }}>
              {trend > 0 ? '↑' : '↓'} {Math.abs(trend)}%
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  card: {
    backgroundColor: '#fff',
    borderRadius: '12px',
    padding: '20px',
    display: 'flex',
    gap: '20px',
    alignItems: 'center',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    transition: 'transform 0.3s, box-shadow 0.3s',
    cursor: 'pointer',
  },
  iconContainer: {
    width: '60px',
    height: '60px',
    borderRadius: '12px',
    backgroundColor: '#F8F9FA',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  content: {
    flex: 1,
  },
  title: {
    fontSize: '13px',
    color: '#999',
    fontWeight: '500',
    marginBottom: '8px',
  },
  value: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#1A1A2E',
    marginBottom: '8px',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  subtitle: {
    fontSize: '12px',
    color: '#666',
  },
  trend: {
    fontSize: '12px',
    fontWeight: 'bold',
  },
};

export default GlobalStatsCard;